<template>
  <div
    class="pmp-dropdown-field"
    :class="{ 'is-open': isOpen }"
    ref="dropdownRef"
  >
    <label v-if="label" class="pmp-form-label">
      {{ label }}
    </label>

    <div class="pmp-dropdown">
      <button
        type="button"
        class="pmp-dropdown-trigger"
        :class="{
          'has-value': selectedOption,
          'is-error': error
        }"
        role="combobox"
        :aria-expanded="isOpen"
        @click="toggle"
        @keydown.escape.prevent="close"
      >
        <template v-if="selectedOption">
          <span
            v-if="selectedOption.hex"
            class="pmp-color-swatch"
            :style="{ background: selectedOption.hex }"
          ></span>

          <span
            v-if="selectedOption.code"
            class="pmp-product-code"
          >
            {{ selectedOption.code }}
          </span>

          <span class="pmp-dropdown-name">
            {{ selectedOption.label }}
          </span>
        </template>

        <span v-else class="pmp-dropdown-placeholder">
          {{ placeholder }}
        </span>

        <span class="pmp-chevron" aria-hidden="true">
          <i class="bi bi-chevron-down"></i>
        </span>
      </button>

      <div class="pmp-dropdown-menu" :class="{ open: isOpen }">
        <button
          v-for="option in options"
          :key="option.value"
          type="button"
          class="pmp-dropdown-option"
          :class="{ selected: option.value === modelValue }"
          @click="selectOption(option)"
        >
          <span
            v-if="option.hex"
            class="pmp-color-swatch"
            :style="{ background: option.hex }"
          ></span>

          <span
            v-if="option.code"
            class="pmp-product-code"
          >
            {{ option.code }}
          </span>

          <span class="pmp-dropdown-option-label">
            {{ option.label }}
          </span>

          <i
            v-if="option.value === modelValue"
            class="bi bi-check2 pmp-check"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </div>

    <p v-if="error && errorMessage" class="pmp-error-message">
      {{ errorMessage }}
    </p>

    <p v-else-if="helper" class="pmp-helper-text">
      {{ helper }}
    </p>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: 'Seleccionar'
  },
  options: {
    type: Array,
    default: () => []
  },
  error: {
    type: Boolean,
    default: false
  },
  errorMessage: {
    type: String,
    default: ''
  },
  helper: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue', 'select', 'blur'])

const isOpen = ref(false)
const dropdownRef = ref(null)

const selectedOption = computed(() => {
  return props.options.find((option) => option.value === props.modelValue)
})

function toggle() {
  isOpen.value = !isOpen.value
}

function close() {
  if (!isOpen.value) return

  isOpen.value = false
  emit('blur')
}

function selectOption(option) {
  emit('update:modelValue', option.value)
  emit('select', option)
  close()
}

function handleClickOutside(event) {
  if (!dropdownRef.value) return

  if (!dropdownRef.value.contains(event.target)) {
    close()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>